const { InnerBlocks } = wp.blockEditor;

export default ({ attributes }) => {
  const { containerized, useIn, variant, placeholder, margin } = attributes;

  const svgColor = variant === 'default' ? '#ACACAC' : '#FFFFFF';

  return (
    <div className={`custom-search ${variant} ${margin} ${useIn}`}>
      <div className={`${containerized ? 'Container' : ''}`}>
        <InnerBlocks.Content />

        <form className="search-form">
          <label>
            <input
              className="custom-search-input"
              type="search"
              placeholder={placeholder}
              disabled
              value=""
            />

            <svg
              width="24"
              height="24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.815 20.458c5.16 0 9.345-4.328 9.345-9.666 0-5.34-4.184-9.667-9.345-9.667-5.16 0-9.344 4.328-9.344 9.667 0 5.338 4.183 9.666 9.344 9.666ZM22.496 22.875l-5.081-5.256"
                stroke={svgColor}
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </label>
        </form>
      </div>
    </div>
  );
};
